import { useQuery } from '@tanstack/react-query';
import { useUserIdentityState } from '@provider/user-identity';
import { DAYS_TO_MS, SECONDS_TO_MS } from '@utils/constants';
import { getCoursesForStudentRequest } from './request.get-all.student.js';
import { getCoursesForTeacherRequest } from './request.get-all.teacher.js';

const getAllCoursesQueryKey = user => ["course-builder/get-all-courses", user?.id];
const getAllCoursesQuery = user => {
  return {
    staleTime: 15 * SECONDS_TO_MS,
    gcTime: 7 * DAYS_TO_MS,
    meta: {
      persist: true
    },
    queryKey: getAllCoursesQueryKey(user),
    queryFn: () => {
      switch (user?.role) {
        case "student":
          return getCoursesForStudentRequest(user.id);
        case "teacher":
          return getCoursesForTeacherRequest(user);
        default:
          return [];
      }
    }
  };
};
const useGetAllCoursesQuery = extraConfig => {
  const user = useUserIdentityState(state => state.user);
  return useQuery({
    ...getAllCoursesQuery(user),
    ...extraConfig
  });
};

export { getAllCoursesQuery, getAllCoursesQueryKey, useGetAllCoursesQuery };
//# sourceMappingURL=query.get-all.js.map
